import { type HttpClientConfig } from '../../infra/http/HttpClient'
import { type ChatContactInfo, type Conversation } from '../domain/Chat'
import { ChatRepository } from '../infra/ChatRepository'
import { createChatHttpClient } from '../infra/createChatHttpClient'

export type CreateConversationRepositoryParams = {
  repository: ChatRepository
}

export type CreateConversationBody = {
  subject: string
  carrier?: ChatContactInfo
  shipper: {
    name: string
    email: string
  }
  entityIdentifier: string
}

export async function getOrCreateConversation(
  { subject, shipper, carrier, entityIdentifier }: CreateConversationBody,
  config?: Partial<HttpClientConfig>,
  accessToken?: string
): Promise<Conversation> {
  const httpClient = createChatHttpClient(accessToken)
  const repository = new ChatRepository({ httpClient })

  const carrierContact = carrier ?? (await repository.getUserContactInfo(config))
  const shipperContact = await repository.createChatContact(
    {
      name: shipper.name,
      type: 'shipper',
      account: {
        name: shipper.name,
        email: shipper.email,
        type: 'shipper',
      },
    },
    config
  )

  return repository.getOrCreateConversation(
    {
      participants: [
        { uuid: carrierContact.uuid, type: 'carrier' },
        { uuid: shipperContact.account.uuid, type: 'shipper' },
      ],
      subject,
      type: 'group',
      context: {
        source: 'shipper_guide',
        entity_name: 'rate',
        entity_pk: entityIdentifier,
      },
    },
    config
  )
}
